const PlusIcon = () => {
  return (
    <svg viewBox="0 0 18 17.999">
      <path
        d="M55.883,46.934a1.5,1.5,0,0,0-1.473,1.517v5.985H48.425a1.5,1.5,0,1,0,0,2.993H54.41v5.985a1.5,1.5,0,1,0,2.993,0V57.429h5.985a1.5,1.5,0,1,0,0-2.993H57.4V48.451a1.5,1.5,0,0,0-1.52-1.517Z"
        transform="translate(-46.906 -46.934)"
      />
    </svg>
  );
};

export default PlusIcon;
